module.exports = __webpack_public_path__ + "static/media/signage-indoor-img59.079aca51.jpg";